










import { Component, Vue, Prop } from 'vue-property-decorator';
import avatar from 'vue-avatar';
@Component({
  components: {
    avatar,
  },
})
export default class WlAvatar extends Vue {
  @Prop() userInfo;
  @Prop() size;
  @Prop() classNames;
  get fullName() {
    return `${this.userInfo.firstName} ${this.userInfo.lastName}`;
  }
  get profilePicUrl() {
    return (
      (this.userInfo.profilePicBasePath || '') +
      this.userInfo.userProfileBasePath +
      (this.userInfo.profilePicGUID || this.userInfo.profilePicGuid) +
      '.' +
      this.userInfo.profilePicExtType
    );
  }
}
